module.exports = __webpack_public_path__ + "media/images/sensacoes-3eb7ff4dc2683bf093e9484a689792ab.svg";